"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncLoadScript = exports.loadScript = void 0;
const loadScript = (where, attrs, opts) => {
    const script = document.createElement("script");
    script.type = "text/javascript";
    for (const key in attrs)
        script[key] = attrs[key];
    const parent = typeof where === 'string' ? document[where] : where;
    parent.appendChild(script);
    if ((opts === null || opts === void 0 ? void 0 : opts.removeSelf) !== false) {
        script.addEventListener('error', () => parent.removeChild(script));
        script.addEventListener('load', () => parent.removeChild(script));
    }
    return script;
};
exports.loadScript = loadScript;
const asyncLoadScript = (where, attrs, opts) => __awaiter(void 0, void 0, void 0, function* () {
    return new Promise((resolve, reject) => {
        const script = (0, exports.loadScript)(where, attrs);
        script.addEventListener('error', e => reject(e));
        script.addEventListener('load', e => resolve(e));
    });
});
exports.asyncLoadScript = asyncLoadScript;
//# sourceMappingURL=ScriptLoader.js.map